import styled from 'styled-components'

export const Content = styled.div`
    background-color: #e6ebff;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 36.75rem;

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        height: 36.25rem;
        width: 100%;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        height: 40.125rem;
        width: 100%;
    }
`

export const Title = styled.div`
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5rem;
    margin: 2rem 0 1.5rem 0;
    max-width: 14.125rem;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        margin: 2rem 0 1.5rem 0;
        font-weight: 700;
        max-width: 43.75rem;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        margin: 3.375rem 0 1.563rem 0;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 133%;
        max-width: 62.5rem;
    }
`
type ContentSwiperProps = {
    centerCards: string
    cardsLength: string | number
}

export const ContentSwiper = styled.div<ContentSwiperProps>`
    display: flex;
    max-width: 81.25rem;
    width: 100%;
    .prev-btn {
        display: none;
    }

    & > .swiper {
        height: 31.25rem;
        width: 100%;

        & > .swiper-wrapper {
            top: 4.688rem;
        }
    }

    img {
        top: -4.688rem;
    }

    svg {
        height: 1.5rem;
        width: 1.5rem;
        color: #002199;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        padding: 0 1.625rem;

        img {
            top: -4.688rem;
        }

        & > .swiper {
            height: 31.25rem;

            & > .swiper-wrapper {
                top: 4.688rem;
                padding-left: 1.5rem;
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        & > .swiper {
            height: 31.25rem;

            & > .swiper-wrapper {
                top: 4.688rem;
                padding-left: ${props => props.cardsLength};
                justify-content: ${props => props.centerCards};
            }
        }

        span:first-child {
            margin-right: 2rem;
        }

        .prev-btn {
            display: flex;
        }
    }
`
